import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isRetiredPublicSurface } from '../utils/publicMarketplace';

function PublicSitePaused() {
  useEffect(() => {
    const previousTitle = document.title;
    const existing = document.head.querySelector('meta[name="robots"]');
    const robots = existing || document.createElement('meta');
    const previous = robots.getAttribute('content');
    robots.name = 'robots'; robots.content = 'noindex,follow';
    if (!existing) document.head.appendChild(robots);
    document.title = 'This public site is unavailable | PlateOS';
    return () => { document.title = previousTitle; if (existing) { if (previous === null) robots.removeAttribute('content'); else robots.content = previous; } else robots.remove(); };
  }, []);
  return <main className="min-h-screen bg-[#f9faf6] text-[#173c31] flex items-center justify-center p-8"><div className="max-w-xl"><p className="font-semibold tracking-tight text-2xl mb-12">PlateOS.</p><h1 className="text-4xl font-medium tracking-tight mb-5">This public site is unavailable.</h1><p className="text-slate-600 mb-8">For an existing order, use the contact or tracking details in your confirmation. Explore PlateOS for food-business software.</p><a href="https://plateos.io/" className="inline-block rounded-full bg-[#d4f573] px-6 py-3 font-semibold">Explore PlateOS</a></div></main>;
}

export default function PublicMarketplaceGate({ children }) {
  const location = useLocation();
  if (isRetiredPublicSurface(window.location.hostname, location.pathname)) return <PublicSitePaused />;
  if (location.pathname === '/get-started' || location.pathname === '/get-started/') {
    const intent = new URLSearchParams(location.search).get('intent');
    return <Navigate to={intent === 'orderhub' ? '/signup?intent=orderhub' : '/signup'} replace />;
  }
  return children;
}
